
import axios from 'axios';
import {
    API,
    API_FAILURE,
    GET_QUOTATION_LIST,
    config,
    API_REQUEST,
    CHECK_RFQ_BULK_UPLOAD,
    SELECTED_ROW_ARRAY,
    SET_QUOTATION_ID_FOR_RFQ,
    GET_NFR_SELECT_LIST,
    GET_RFQ_VENDOR_DETAIL,
    GET_TARGET_PRICE,
    GET_ASSEMBLY_CHILD_PART,
    GET_RFQ_PART_DETAILS,
    GET_RFQ_RAISE_NUMBER,
    GET_QUOTATION_DETAILS_LIST,
    GET_PART_IDENTITY,
    GET_QUOTATION_ID_FOR_RFQ,
    SET_RM_SPECIFIC_ROW_DATA,
    SELECT_PURCHASE_REQUISITION,
    SELECT_BOP_NUMBER,
    SELECT_BOP_CATEGORY,
    SET_BOP_SPECIFIC_ROW_DATA,
    GET_BOP_PR_QUOTATION_DETAILS,
    SET_BOP_PR_QUOTATION_IDENTITY,
    UPDATED_TOOLING_DATA,
    SET_TOOLING_SPECIFIC_ROW_DATA,
    BEST_COSTING_DATA,
    SEND_TO_APPROVER,
    GET_APPROVALS_BY_FILTER,
    GET_APPROVAL_RFQ_SUMMARY,
    GET_CHAT_MESSAGES,
    SEND_CHAT_MESSAGE,
    UPLOAD_CHAT_FILES,
} from '../../../config/constants';
import { MESSAGES } from '../../../config/message';
import { getConfigurationKey, loggedInUserId, userDetails } from '../../../helper';
import { apiErrors } from '../../../helper/util';
import Toaster from '../../common/Toaster';


export function getQuotationList(queryParams, callback) {
    return (dispatch) => {
        const request = axios.get(`${API?.getQuotationList}?${queryParams}`, config());
        request.then((response) => {
            if (response?.data?.Result || response?.status === 204) {
                dispatch({
                    type: GET_QUOTATION_LIST,
                    payload: response?.status === 204 ? [] : response?.data?.DataList
                })
                callback(response);
            }
        }).catch((error) => {
            dispatch({ type: API_FAILURE });
            apiErrors(error);
            callback(error);
        });
    };
}


export function createRfqQuotation(data, callback) {


    return (dispatch) => {
        const request = axios.post(API?.createRfqQuotation, data, config());
        request.then((response) => {
            dispatch({
                type: GET_QUOTATION_ID_FOR_RFQ,
                payload: response?.status === 204 ? "" : response?.data?.Identity
            })
            if (response?.data?.Result) {
                callback(response);
            }
        }).catch((error) => {
            dispatch({ type: API_FAILURE });
            apiErrors(error);
            callback(error)
        });
    };
}

export function cancelRfqQuotation(id, callback) {
    let data = { QuotationId: id }
    return (dispatch) => {
        const request = axios.post(`${API?.cancelRfqQuotation}`, data, config());
        request.then((response) => {
            if (response?.data?.Result) {
                callback(response);
            }
        }).catch((error) => {
            dispatch({ type: API_FAILURE });
            apiErrors(error);
            callback(error)
        });
    };
}

export function updateRfqQuotation(data, callback) {

    return (dispatch) => {
        const request = axios.post(API?.updateRfqQuotation, data, config());
        request.then((response) => {
            if (response?.data?.Result) {
                callback(response);
            }
        }).catch((error) => {
            dispatch({ type: API_FAILURE });
            apiErrors(error);
            callback(error)
        });
    };
}


export function getQuotationById(id, callback) {
    return (dispatch) => {
        axios.get(`${API?.getQuotationById}?quotationId=${id}`, config())
            .then((response) => {
                callback(response)
            }).catch((error) => {

                dispatch({ type: API_FAILURE });
                apiErrors(error);
            });
    };
}


/**
 * @method fileUploadQuotation
 * @description File Upload Quotation
 */
export function fileUploadQuotation(data, callback) {

    return (dispatch) => {
        const request = axios.post(API?.fileUploadQuotation, data, config())
        request.then((response) => {
            if (response && response?.status === 200) {
                callback(response)
            }
        }).catch((error) => {
            dispatch({ type: API_FAILURE })
            apiErrors(error)
            callback(error)
        })
    }
}




/**
 * @method fileDeleteQuotation
 * @description DELETE QUOTATION FILES
 */
export function fileDeleteQuotation(data, callback) {
    return (dispatch) => {
        dispatch({ type: API_REQUEST })
        axios.delete(`${API?.fileDeleteQuotation}/${data.Id}/${data.DeletedBy}`, config())
            .then((response) => {
                callback(response)
            }).catch((error) => {
                apiErrors(error)
                dispatch({ type: API_FAILURE })
            })
    }
}



export function sendReminderForQuotation(data, callback) {

    return (dispatch) => {
        const request = axios.post(API?.sendReminderForQuotation, data, config());
        request.then((response) => {
            if (response?.data?.Result) {
                callback(response);
            }
        }).catch((error) => {
            dispatch({ type: API_FAILURE });
            apiErrors(error);
            callback(error)
        });
    };
}


export function getContactPerson(vendorId, callback) {
    return (dispatch) => {
        const request = axios.get(`${API?.getContactPerson}?vendorId=${vendorId}`, config());
        request.then((response) => {
            callback(response)
        }).catch((error) => {
            dispatch({ type: API_FAILURE });
            apiErrors(error);
        });
    };
}

export function deleteQuotationPartDetail(partId, callback) {
    const quotationPartId = Number(partId)
    return (dispatch) => {
        axios.delete(`${API?.deleteQuotationPartDetail}?quotationPartId=${quotationPartId}`, config())
            .then((response) => {
                callback(response)
            }).catch((error) => {
                apiErrors(error)
                dispatch({ type: API_FAILURE })
            })

    };
}

export function getQuotationDetailsList(id, callback) {

    return (dispatch) => {
        const request = axios.get(`${API?.getQuotationDetailsList}?quotationId=${id}&loggedInUserId=${loggedInUserId()}`, config());
        request.then((response) => {
            if (response?.data?.Result) {
                dispatch({ type: GET_QUOTATION_DETAILS_LIST, payload: response?.data?.DataList })
                callback(response);
            } else {
                callback(response?.status)
            }
        }).catch((error) => {
            dispatch({ type: API_FAILURE });
            apiErrors(error);
            callback(error)
        });
    };
}


/**
 * @method getSingleCostingDetails
 * @description Used to fetch costing details by costingId
 */
export function getMultipleCostingDetails(selectedRows, callback) {
    return (dispatch) => {
        dispatch({ type: API_REQUEST })

        let temp = []
        selectedRows && selectedRows.map((item) => {
            if (item.CostingId !== null) {
                let request = axios.get(`${API?.getCostingDetailsByCostingId}/${item.CostingId}`, config(),)
                temp.push(request)
            }
        })

        axios.all(temp).then((response) => {
            if (response) {
                callback(response)
            } else {
                Toaster.error(MESSAGES.SOME_ERROR)
            }
        }).catch((error) => {
            dispatch({ type: API_FAILURE })
            apiErrors(error)
        })
    }
}



export function getCommunicationHistory(data, callback) {
    // export function getCommunicationHistory(id, callback) {      //RE
    return (dispatch) => {
        axios.get(`${API?.getCommunicationHistory}?quotationId=${data.quotationId}&partId=${data.partId}&vendorId=${data.vendorId}&timeZone=${data.timeZone}`, config())
            // axios.get(`${API?.getCommunicationHistory}?costingId=${id}`, config())      //RE
            .then((response) => {
                callback(response)
            }).catch((error) => {
                dispatch({ type: API_FAILURE });
                apiErrors(error);
            });
    };
}



export function checkExistCosting(data, callback) {
    return (dispatch) => {
        const request = axios.post(API?.checkExistCosting, data, config());
        request.then((response) => {
            if (response?.data?.Result) {
                callback(response);
            }
        }).catch((error) => {
            dispatch({ type: API_FAILURE });
            apiErrors(error);
            callback(error)
        });
    };
}

//CHECK FOR VENDOR AND PLANT FOR LPS AND SCN
export function checkLPSAndSCN(data, callback) {
    return (dispatch) => {
        const request = axios.get(`${API?.getVendorPlantClassificationLpsratingForRFQ}?vendorId=${data.VendorId}&plantId=${data.PlantId}`, config());
        request.then((response) => {
            if (response?.data?.Result) {
                callback(response);
            } else {
                callback({ error: 'Unexpected result format' });
            }
        }).catch((error) => {
            dispatch({ type: API_FAILURE });
            apiErrors(error);
            callback({ error });
        });
    };
}

export function checkRFQBulkUpload(data, callback) {
    return (dispatch) => {
        const request = axios.post(API?.checkRFQBulkUpload, data, config());
        request.then((response) => {
            if (response?.data?.Result || response?.status === 204) {
                dispatch({
                    type: CHECK_RFQ_BULK_UPLOAD,
                    payload: response?.status === 204 ? [] : response?.data?.Data
                })
            }
            callback(response);
        }).catch((error) => {
            dispatch({ type: API_FAILURE });
            apiErrors(error);
            callback(error);
        });
    };
}
export function checkComponentOrAssemblyRFQBulkUpload(data, callback) {
    return (dispatch) => {
        const request = axios.post(API?.checkComponentOrAssemblyRFQBulkUpload, data, config());
        request.then((response) => {
            if (response?.data?.Result || response?.status === 204) {
                dispatch({
                    type: CHECK_RFQ_BULK_UPLOAD,
                    payload: response?.status === 204 ? [] : response?.data?.Data
                })
            }
            callback(response);
        }).catch((error) => {
            dispatch({ type: API_FAILURE });
            apiErrors(error);
            callback(error.response);
        });
    };
}
export function checkRawMaterialRFQBulkUpload(data, callback) {
    return (dispatch) => {
        const request = axios.post(API?.checkRawMaterialRFQBulkUpload, data, config());
        request.then((response) => {

            if (response?.data?.Result || response?.status === 204) {
                dispatch({
                    type: CHECK_RFQ_BULK_UPLOAD,
                    payload: response?.status === 204 ? [] : response?.data?.Data
                })
            }
            callback(response);
        }).catch((error) => {
            dispatch({ type: API_FAILURE });
            apiErrors(error);
            callback(error.response);
        });
    };
}
export function checkBoughtOutPartsRFQBulkUpload(data, callback) {
    return (dispatch) => {
        const request = axios.post(API?.checkBoughtOutPartsRFQBulkUpload, data, config());
        request.then((response) => {

            if (response?.data?.Result || response?.status === 204) {
                dispatch({
                    type: CHECK_RFQ_BULK_UPLOAD,
                    payload: response?.status === 204 ? [] : response?.data?.Data
                })
            }
            callback(response);
        }).catch((error) => {
            dispatch({ type: API_FAILURE });
            apiErrors(error);
            callback(error.response);
        });
    };
}

export function setRFQBulkUpload(data) {
    return (dispatch) => {
        dispatch({
            type: CHECK_RFQ_BULK_UPLOAD,
            payload: data
        })
    };
}

export function getQuotationDetailsByVendor(data, callback) {
    return (dispatch) => {
        axios.get(`${API?.getQuotationDetailsByVendor}?vendorId=${userDetails().VendorId}&quotationId=${data}`, config())
            .then((response) => {
                callback(response)
            }).catch((error) => {
                dispatch({ type: API_FAILURE });
                apiErrors(error);
            });
    };
}

export function setSelectedRow(data) {
    return (dispatch) => {
        dispatch({
            type: SELECTED_ROW_ARRAY,
            payload: data
        })
    }
}

/**
 * @method setQuotationIdForRFQ
 * @description set Quotation Id For RFQ
 */
export function setQuotationIdForRFQ(data) {
    return (dispatch) => {
        dispatch({
            type: SET_QUOTATION_ID_FOR_RFQ,
            payload: data,
        });
    }
};

export function rfqSaveBestCosting(data, callback) {
    return (dispatch) => {
        const request = axios.post(API?.rfqSaveBestCosting, data, config());
        request.then((response) => {
            if (response?.data?.Result) {
                callback(response);
            }
        }).catch((error) => {
            dispatch({ type: API_FAILURE });
            apiErrors(error);
            callback(error)
        });
    };
}

export function getNfrSelectList(callback) {
    return (dispatch) => {
        axios.get(`${API?.getNfrSelectList}`, config())
            .then((response) => {

                if (response?.data?.Result || response?.status === 204) {

                    dispatch({
                        type: GET_NFR_SELECT_LIST,
                        payload: response?.status === 204 ? [] : response?.data?.SelectList
                    })

                    callback(response);
                }
            }).catch((error) => {
                dispatch({ type: API_FAILURE });
                apiErrors(error);
            });
    };
}

export function rfqGetBestCostingDetails(bestCostId, callback) {
    return (dispatch) => {
        const request = axios.get(`${API?.rfqGetBestCostingDetails}?bestCostId=${bestCostId}`, config());
        request.then((response) => {
            if (response?.data?.Result || response?.status === 204) {
                const tempObj = response?.data?.Data;

                // Format the data based on type
                let formattedData = null;

                 if (tempObj?.BoughtOutPartBestCostRequest) {
                    formattedData = {
                        BestCostId: tempObj.BestCostId,
                        bestCost: '',
                        BasicRateConversion : tempObj?.BoughtOutPartBestCostRequest?.BasicRate,
                        NetLandedCostConversion : tempObj?.BoughtOutPartBestCostRequest?.NetBoughtOutPartCost,
                        OtherNetCostConversion : tempObj?.BoughtOutPartBestCostRequest?.OtherCost,
                        nPOPrice : tempObj?.BoughtOutPartBestCostRequest?.POPrice,
                        QuotationPartId : tempObj?.BoughtOutPartBestCostRequest?.QuotationPartId,
                        UOM: '',
                        Plants: '',
                        Vendor: '',
                        VendorCode: '',
                        EffectiveDate: null,
                        Attachements: [],
                        BoughtOutPartOtherCostDetailsSchema: []
                    };
                } else if (tempObj?.RawMaterialBestCostRequest) {
                    formattedData = {
                        BestCostId: tempObj.BestCostId,
                        bestCost: '',
                        BasicRateConversion : tempObj?.RawMaterialBestCostRequest?.BasicRate,
                        NetLandedCostConversion : tempObj?.RawMaterialBestCostRequest?.NetLandedCost,
                        OtherNetCostConversion : tempObj?.RawMaterialBestCostRequest?.OtherNetCost,
                        nPOPrice : tempObj?.RawMaterialBestCostRequest?.POPrice,
                        QuotationPartId : tempObj?.RawMaterialBestCostRequest?.QuotationPartId,
                        UOM: '',
                        Plants: '',
                        Vendor: '',
                        VendorCode: '',
                        EffectiveDate: null,
                        Attachements: [],
                        RawMaterialOtherCostDetailsSchema: []
                    };
                }

                // Store in bestCostingData reducer only
                dispatch({
                    type: BEST_COSTING_DATA,
                    payload: formattedData || []
                });

                callback(response);
            }
        }).catch((error) => {
            dispatch({ type: API_FAILURE });
            apiErrors(error);
            callback(error)
        });
    };
}

export function getNfrAnnualForecastQuantity(nfrId, partId, sopDate, callback) {
    return (dispatch) => {
        const request = axios.get(`${API?.getNfrAnnualForecastQuantity}?nfrId=${nfrId}&partId=${partId}&sopDate=${sopDate}`, config());
        request.then((response) => {
            if (response?.data?.Result) {
                callback(response);
            }
        }).catch((error) => {
            dispatch({ type: API_FAILURE });
            apiErrors(error);
            callback(error)
        });
    };
}

export function getNFRRMList(nfrId, partId, sopDate, callback) {
    return (dispatch) => {
        const request = axios.get(`${API?.getNFRRMList}?nfrId=${nfrId}&partId=${partId}&sopDate=${sopDate}`, config());
        request.then((response) => {
            if (response?.data?.Result) {
                callback(response);
            }
        }).catch((error) => {
            dispatch({ type: API_FAILURE });
            apiErrors(error);
            callback(error)
        });
    };
}

export function getPartNFRRMList(nfrId, partId, callback) {
    return (dispatch) => {
        const request = axios.get(`${API?.getNFRPartRMList}?nfrId=${nfrId}&partId=${partId}`, config());
        request.then((response) => {
            if (response?.data?.Result) {
                callback(response);
            }
        }).catch((error) => {
            dispatch({ type: API_FAILURE });
            apiErrors(error);
            callback(error)
        });
    };
}
export function getTargetPrice(plantId, partId, technologyId, callback) {
    const plantIds = Array.isArray(plantId) ? plantId : [plantId]
    return (dispatch) => {
        const payload = {
            plantIds: plantIds,
            partId: partId,
            technologyId: technologyId
        };
        const request = axios.post(`${API?.getTargetPrice}`, payload, config());
        request.then((response) => {
            if (response?.data?.Result || response?.status === 204) {

                dispatch({
                    type: GET_TARGET_PRICE,
                    payload: response?.status === 204 ? [] : response?.data?.Data
                })

                callback(response);
            }
        }).catch((error) => {
            dispatch({ type: API_FAILURE });
            apiErrors(error);
        });
    };
}

export function setVendorDetails(data) {
    return (dispatch) => {
        dispatch({
            type: GET_RFQ_VENDOR_DETAIL,
            payload: data || {},
        });
    }
};
export function setTargetPriceDetail(data) {
    return (dispatch) => {
        dispatch({
            type: GET_TARGET_PRICE,
            payload: data || {},
        });
    }
};
export function setRfqPartDetails(data) {
    return (dispatch) => {
        dispatch({
            type: GET_RFQ_PART_DETAILS,
            payload: data || {},
        });
    }
};
export function getAssemblyChildpart(partId, callback) {
    return (dispatch) => {
        const request = axios.get(`${API?.getAssemblyChildpart}?partId=${partId}`, config());
        request.then((response) => {

            if (response?.data?.Result || response?.status === 204) {

                dispatch({
                    type: GET_ASSEMBLY_CHILD_PART,
                    payload: response?.status === 204 ? [] : response?.data?.DataList
                })

                callback(response);
            }
        }).catch((error) => {
            dispatch({ type: API_FAILURE });
            apiErrors(error);
        });
    };
}
export function getrRqVendorDetails(vendorId, callback) {
    return (dispatch) => {
        const request = axios.get(`${API?.getrRqVendorDetails}?vendorId=${vendorId}`, config());
        request.then((response) => {
            if (response?.data?.Result || response?.status === 204) {

                dispatch({
                    type: GET_RFQ_VENDOR_DETAIL,
                    payload: response?.status === 204 ? [] : response?.data?.Data
                })

                callback(response);
            }
        }).catch((error) => {
            dispatch({ type: API_FAILURE });
            apiErrors(error);
        });
    };
}

export function saveRfqPartDetails(data, callback) {

    return (dispatch) => {
        const request = axios.post(API?.saveRfqPartDetails, data, config());
        request.then((response) => {

            if (response?.data?.Result) {
                dispatch({
                    type: GET_PART_IDENTITY,
                    payload: response?.status === 204 ? [] : response?.data?.Identity
                })
                callback(response);
            }
        }).catch((error) => {

            dispatch({ type: API_FAILURE });
            apiErrors(error);
            callback(error)
        });
    };
}

export function getRfqPartDetails(partId, callback) {

    const quotationPartId = Number(partId)

    return (dispatch) => {
        dispatch({
            type: GET_RFQ_PART_DETAILS,
            payload: []
        })
        const request = axios.get(`${API?.getRfqPartDetails}?quotationPartId=${quotationPartId}`, config());
        request.then((response) => {
            if (response?.data?.Result || response?.status === 204) {

                dispatch({
                    type: GET_RFQ_PART_DETAILS,
                    payload: response?.status === 204 ? [] : response?.data?.Data
                })

                callback(response);
            }
        }).catch((error) => {

            dispatch({ type: API_FAILURE });
            apiErrors(error);
        });
    };
}
export function setQuotationIdForRfq(data) {
    return (dispatch) => {
        dispatch({
            type: GET_QUOTATION_ID_FOR_RFQ,
            payload: data || "",
        });
    }
};
export function checkRegisteredVendor(vendorId, callback) {
    return (dispatch) => {
        const request = axios.get(`${API?.checkRegisteredVendor}?vendorId=${vendorId}`, config());
        request.then((response) => {
            if (response?.data?.Result || response?.status === 204) {
                callback(response);
            }
        }).catch((error) => {
            dispatch({ type: API_FAILURE });
            apiErrors(error);
        });
    };
}

export function setRmSpecificRowData(data) {

    return (dispatch) => {
        dispatch({
            type: SET_RM_SPECIFIC_ROW_DATA,
            payload: data || [],
        });
    }
};

export function getPurchaseRequisitionSelectList(filterData, callback) {



    return (dispatch) => {
        dispatch({
            type: SELECT_PURCHASE_REQUISITION,
            payload: []
        })
        //const request = axios.get(`${API?.getPurchaseRequisitionSelectList}`, config());
        const request = axios.get(`${API?.getPurchaseRequisitionSelectList}?PartType=${Number(filterData?.partType)}&PlantId=${filterData?.plantId}`, config());
        request.then((response) => {

            if (response?.data?.Result || response?.status === 204) {

                dispatch({
                    type: SELECT_PURCHASE_REQUISITION,
                    payload: response?.status === 204 ? [] : response?.data?.SelectList
                })

                callback(response);
            }
        }).catch((error) => {


            dispatch({ type: API_FAILURE });
            apiErrors(error);
        });
    };
}
export function getBopNumberSelectList(callback) {

    return (dispatch) => {
        dispatch({
            type: SELECT_BOP_NUMBER,
            payload: []
        })
        const request = axios.get(`${API?.getRfqBopNumberSelectList}`, config());
        request.then((response) => {

            if (response?.data?.Result || response?.status === 204) {

                dispatch({
                    type: SELECT_BOP_NUMBER,
                    payload: response?.status === 204 ? [] : response?.data?.SelectList
                })

                callback(response);
            }
        }).catch((error) => {


            dispatch({ type: API_FAILURE });
            apiErrors(error);
        });
    };
}
export function getBopCategorySelectList(boughtOutPartChildId, callback) {
    return (dispatch) => {
        dispatch({
            type: SELECT_BOP_CATEGORY,
            payload: []
        })
        const request = axios.get(`${API?.getRfqBOPCategorySelectList}/${boughtOutPartChildId}`, config());
        request.then((response) => {
            if (response?.data?.Result || response?.status === 204) {

                dispatch({
                    type: SELECT_BOP_CATEGORY,
                    payload: response?.status === 204 ? [] : response?.data?.SelectList
                })

                callback(response);
            }
        }).catch((error) => {

            dispatch({ type: API_FAILURE });
            apiErrors(error);
        });
    };
}
export function setBopSpecificRowData(data) {

    return (dispatch) => {
        dispatch({
            type: SET_BOP_SPECIFIC_ROW_DATA,
            payload: data || [],
        });
    }
};
export function createQuotationPrParts(data, callback) {
    const prNumbersId = Number(data.prNumbersId)
    return (dispatch) => {
        const request = axios.post(API?.createQuotationPrParts, data, config());
        request.then((response) => {

            if (response?.data?.Result) {
                dispatch({
                    type: SET_BOP_PR_QUOTATION_IDENTITY,
                    payload: response?.status === 204 ? [] : response?.data?.Identity
                })
                callback(response);
            }
        }).catch((error) => {
            dispatch({ type: API_FAILURE });
            apiErrors(error);
            callback(error)
        });
    };
};
export function setToolingSpecificRowData(data) {


    return (dispatch) => {
        dispatch({
            type: SET_TOOLING_SPECIFIC_ROW_DATA,
            payload: data || [],
        });
    }
};
export function sendQuotationForReview(data, callback) {

    return (dispatch) => {
        const request = axios.post(API?.sendQuotationForReview, data, config());
        request.then((response) => {
            if (response?.data?.Result) {
                callback(response);
            }
        }).catch((error) => {
            dispatch({ type: API_FAILURE });
            apiErrors(error);
            callback(error)
        });
    };
}
export function getRfqReviewHistory(data, callback) {

    return (dispatch) => {
        axios.get(`${API?.getRfqReviewHistory}?quotationId=${data.quotationId}`, config())
            .then((response) => {
                callback(response)
            }).catch((error) => {
                dispatch({ type: API_FAILURE });
                apiErrors(error);
            });
    };
}
export function checkRmExistInRfq(data, callback) {
    return (dispatch) => {
        const request = axios.post(API?.checkRmExistInRfq, data, config());
        request.then((response) => {
            if (response?.data?.Result) {
                callback(response);
            }
        }).catch((error) => {
            dispatch({ type: API_FAILURE });
            apiErrors(error);
            callback(error);
        });
    };
}

export function checkBopExistInRfq(data, callback) {
    return (dispatch) => {
        const request = axios.post(API?.checkBopExistInRfq, data, config());
        request.then((response) => {
            if (response?.data?.Result) {
                callback(response);
            }
        }).catch((error) => {
            dispatch({ type: API_FAILURE });
            apiErrors(error);
            callback(error);
        });
    };
}

// ==================== APPROVAL SYSTEM ACTIONS ====================
// Note: checkFinalUser is already available in costing/actions/Costing.js
// Import and use that instead: import { checkFinalUser } from '../costing/actions/Costing';

/**
 * @method sendToApprover
 * @description Send RFQ to approver for approval
 * @param {Object} params - { rfqId, departmentCode, approverId, reason, remarks, senderId }
 * @param {Function} callback - Callback function
 */
export function sendToApprover(params, callback) {
    return (dispatch) => {
        const request = axios.post(API?.sendRfqToApprover, params, config());
        request.then((response) => {
            if (response?.data?.Result) {
                dispatch({
                    type: SEND_TO_APPROVER,
                    payload: response?.data,
                });
                Toaster.success(response?.data?.Message || 'RFQ sent for approval successfully');
            } else {
                const errorMessage = response?.data?.Message || 'Failed to send RFQ for approval';
                Toaster.error(errorMessage);
            }
            callback(response);
        }).catch((error) => {
            dispatch({ type: API_FAILURE });
            apiErrors(error);
            callback(error);
        });
    };
}

/**
 * @method approveOrRejectRfqByApprover
 * @description Approve or reject RFQ from approval listing
 * @param {Array} dataArray - Array of approval objects with structure:
 * [{
 *   ApprovalProcessSummaryId: string (GUID),
 *   ApprovalToken: number,
 *   LoggedInUserId: string (GUID),
 *   SenderLevelId: string (GUID),
 *   ApproverIdList: Array<string>,
 *   ApproverLevelId: string (GUID),
 *   Remark: string,
 *   IsApproved: boolean,
 *   ApproverDepartmentId: string (GUID),
 *   DivisionId: number,
 *   IsFinalApprovalProcess: boolean,
 *   ReasonId: number,
 *   IsFromUI: boolean,
 *   IsRFQCostingSendForApproval: boolean,
 *   IsReturn: boolean,
 *   ApprovalTriggerSource: string
 * }]
 * @param {Function} callback - Callback function
 */
export function approveOrRejectRfqByApprover(dataArray, callback) {
    return (dispatch) => {
        const request = axios.post(API?.approveOrRejectRfqByApprover, dataArray, config());
        request.then((response) => {
            if (response?.data?.Result || response?.status === 200) {
                const actionType = dataArray[0]?.IsApproved ? 'approved' : 'rejected';
                Toaster.success(response?.data?.Message || `RFQ ${actionType} successfully`);
                callback && callback(response);
            } else {
                const errorMessage = response?.data?.Message || `Failed to ${dataArray[0]?.IsApproved ? 'approve' : 'reject'} RFQ`;
                Toaster.error(errorMessage);
                callback && callback(response);
            }
        }).catch((error) => {
            dispatch({ type: API_FAILURE });
            apiErrors(error);
            callback && callback(error);
        });
    };
}

/**
 * @method getApprovalsByFilter
 * @description Get list of RFQs in approval process
 * @param {Object} params - { departmentCode, loggedInUserId, timeZone, isApplyPagination, skip, take, logged_in_user_level_id }
 * @param {Function} callback - Success callback
 */
export function getApprovalsByFilter(params, callback) {
    return (dispatch) => {
        const queryString = new URLSearchParams(params).toString();
        const request = axios.get(`${API?.getRfqApprovalsByFilter}?${queryString}`, config());

        request.then((response) => {
            // Handle 204 No Content
            if (response?.status === 204) {
                dispatch({
                    type: GET_APPROVALS_BY_FILTER,
                    payload: { data: [], totalCount: 0 },
                });
                callback && callback(response);
                return;
            }

            // Handle 200 OK
            if (response?.status === 200) {
                if (response?.data?.Result === false) {
                    if (response?.data?.Message) {
                        Toaster.error(response.data.Message);
                    }
                } else {
                    const dataList = response?.data?.DataList || response?.data?.data || [];
                    // Extract totalCount from root level or first row's TotalRecordCount
                    let totalCount = response?.data?.TotalCount || response?.data?.totalCount;
                    if (!totalCount && dataList.length > 0 && dataList[0]?.TotalRecordCount) {
                        totalCount = dataList[0].TotalRecordCount;
                    }
                    dispatch({
                        type: GET_APPROVALS_BY_FILTER,
                        payload: {
                            data: dataList,
                            totalCount: totalCount || 0,
                        },
                    });
                }
                callback && callback(response);
            }
        }).catch((error) => {
            dispatch({ type: API_FAILURE });
            apiErrors(error);
            callback && callback(error);
        });
    };
}

/**
 * @method getApprovalRfqSummary
 * @description Get approval summary and timeline for an RFQ
 * @param {String} approvalNumber - Approval number
 * @param {String} rfqApprovalProcessId - RFQ Approval Process ID
 * @param {String} loggedInUserId - Logged in user ID
 * @param {Function} callback - Success callback
 * @param {Function} errorCallback - Error callback
 */
export function getApprovalRfqSummary(approvalNumber, rfqApprovalProcessId, loggedInUserId, callback, errorCallback) {
    return (dispatch) => {
        const url = `${API?.getApprovalRfqSummary}/${approvalNumber}/${rfqApprovalProcessId}/${loggedInUserId}`;
        const request = axios.get(url, config());

        request.then((response) => {
            if (response?.data?.Result || response?.status === 200) {
                dispatch({
                    type: GET_APPROVAL_RFQ_SUMMARY,
                    payload: response?.data?.Data || response?.data,
                });
                callback && callback(response?.data?.Data || response?.data);
            }
        }).catch((error) => {
            dispatch({ type: API_FAILURE });
            apiErrors(error);
            errorCallback && errorCallback(error);
        });
    };
}

/**
 * Get RFQ Approval Listing
 * Fetches all RFQs with their approval status for the Approval Status tab
 * @param {string} userId - Logged in user ID
export function getRfqApprovalList(userId, callback) {
    return (dispatch) => {
        const params = {
            LoggedInUserId: userId,
        };

        const request = axios.post(API?.getRfqApprovalsByFilter, params, config());

        request.then((response) => {
            if (response?.status === 204) {
                dispatch({
                    type: GET_RFQ_APPROVAL_LIST,
                    payload: { data: [], totalCount: 0 },
                });
                callback && callback(response);
                return;
            }
            if (response?.status === 200) {
                if (response?.data?.Result === false) {
                    if (response?.data?.Message) {
                        Toaster.error(response.data.Message);
                    }
                } else {
                    dispatch({
                        type: GET_RFQ_APPROVAL_LIST,
                        payload: {
                            data: response?.data?.DataList || response?.data?.data || [],
                            totalCount: response?.data?.TotalCount || response?.data?.totalCount || 0,
                        },
                    });
                }
                callback && callback(response);
            }
        }).catch((error) => {
            dispatch({ type: API_FAILURE });
            apiErrors(error);
            callback && callback(error);
        });
    };
}
 */
export function getAllRfqApprovalUsersByDepartment(data, callback, suppressError = false) {
    return (dispatch) => {
        dispatch({ type: API_REQUEST });

        const request = axios.post(
            API?.getAllRfqApprovalUsersByDepartment,
            data,
            config()
        );

        request
            .then((response) => {
                if (response?.data?.Result) {
                    callback && callback(response);
                } else {
                    dispatch({ type: API_FAILURE });
                    if (response?.data?.Message && !suppressError) {
                        Toaster.error(response?.data?.Message);
                    }
                    callback && callback(response);
                }
            })
            .catch((error) => {
                dispatch({ type: API_FAILURE });
                if (!suppressError) {
                    apiErrors(error);
                }
                callback && callback(error);
            });
    };
}

/**
 * Get all RFQ approval users filtered by department and level
 * @param {Object} data - Request payload with DepartmentId, LoggedInUserId, and level filters
 * @param {Function} callback - Callback function to handle response
 */
export function getAllRfqApprovalUsersLevelFilterByDepartment(data, callback) {
    return (dispatch) => {
        dispatch({ type: API_REQUEST });

        const request = axios.post(
            API?.getRFQUserLevelApi,
            data,
            config()
        );

        request
            .then((response) => {
                if (response?.data?.Result) {
                    callback && callback(response);
                } else {
                    dispatch({ type: API_FAILURE });
                    if (response?.data?.Message) {
                        Toaster.error(response?.data?.Message);
                    }
                    callback && callback(response);
                }
            })
            .catch((error) => {
                dispatch({ type: API_FAILURE });
                apiErrors(error);
                callback && callback(error);
            });
    };
}

/**
 * @method getChatMessages
 * @description Get chat messages for RFQ quotation
 * @param {Object} payload - Contains QuotationVendorId, QuotationPartId, QuotationPlantId, QuotationCostingId, LoggedInUserId, IsReaderFromBase
 * @param {Function} callback - Success callback
 */
export function getChatMessages(payload, callback) {
    return (dispatch) => {
        dispatch({ type: API_REQUEST });

        const request = axios.post(`${API.getChatMessages}`, payload, config());

        request
            .then((response) => {
                if (response?.status === 200 && response?.data?.Result) {
                    dispatch({
                        type: GET_CHAT_MESSAGES,
                        payload: response?.data?.DataList || []
                    });
                    callback && callback(response);
                } else if (response?.status === 204) {
                    dispatch({
                        type: GET_CHAT_MESSAGES,
                        payload: []
                    });
                    callback && callback(response);
                } else {
                    dispatch({ type: API_FAILURE });
                    if (response?.data?.Message) {
                        Toaster.error(response?.data?.Message);
                    }
                    callback && callback(response);
                }
            })
            .catch((error) => {
                dispatch({ type: API_FAILURE });
                apiErrors(error);
                callback && callback(error);
            });
    };
}

/**
 * @method sendChatMessage
 * @description Send a chat message/reply
 * @param {Object} payload - Contains message data
 * @param {Function} callback - Success callback
 */
export function sendChatMessage(payload, callback) {
    return (dispatch) => {
        dispatch({ type: API_REQUEST });

        const request = axios.post(`${API.sendChatMessage}`, payload, config());

        request
            .then((response) => {
                if (response?.status === 200 && response?.data?.Result) {
                    dispatch({
                        type: SEND_CHAT_MESSAGE,
                        payload: response?.data?.Data
                    });
                    callback && callback(response);
                } else {
                    dispatch({ type: API_FAILURE });
                    if (response?.data?.Message) {
                        Toaster.error(response?.data?.Message);
                    }
                    callback && callback(response);
                }
            })
            .catch((error) => {
                dispatch({ type: API_FAILURE });
                apiErrors(error);
                callback && callback(error);
            });
    };
}

/**
/**
 * Upload chat attachment files
 * API Endpoint: POST /quotation-chat/file-upload
 * Response format: Array with [{FileName, FileURL, OriginalFileName, FileSize, MimeType, Exist}]
 * @param {FormData} data - File data to upload
 * @param {Function} callback - Callback function
 */
export function uploadChatFiles(data, callback) {
    return (dispatch) => {
        const request = axios.post(API?.uploadChatFiles, data, config())
        request.then((response) => {
            if (response && response?.status === 200) {
                callback(response)
            }
        }).catch((error) => {
            dispatch({ type: API_FAILURE })
            apiErrors(error)
            callback(error)
        })
    }
}
